import React, { Component } from "react";
import { connect } from "react-redux";

import PointStepper from "./Setpoints/PointStepper";

//MUI
import { withStyles } from "@material-ui/core/styles";

function mapStateToProps(state) {
  return {
    floors: state.data.data.payload,
    data: Object.keys(state.data.data).length > 1 ? state.data.data : false
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Styles
const styles = theme => ({
  root: {}
});

class Setpoints extends Component {
  state = {
    expanded: null,
    activeStep: 0,
    activeFloor: null,
    activeDevice: null
  };
  render() {
    const { data } = this.props;
    return <PointStepper data={data} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Setpoints));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/dashboard_tabs/Setpoints.js